/**
 * @description This hook provides a functon that, when called with the add knowledge form data,
 *  creates a knowledge entry and reloads the knowledge list.
 */

import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import { ToastContext } from '@seccon/core/contexts/toast';

const useAddKnowledge = () => {
  const toastApi = React.useContext(ToastContext);
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (data) => (
      fetch('/KnowledgeCenter/create', { method: 'POST', body: JSON.stringify(data) })
        .then(decodeJson)
    ),
    // On success, notify the user, clear the knowledge data, and call the onSuccess callback
    onSuccess: () => {
      toastApi.success('Knowledge center entry was created successfully');
      queryClient.invalidateQueries({ queryKey: ['fetchKnowledge'] });
    },
    // On error, notfify the user
    onError: ({ body }) => {
      toastApi.error(body ? `Error: ${ body }` : 'Unable to create knowledge center entry. Please try again.');
    }
  })

  return mutateAsync;
};

export default useAddKnowledge;
